

import type React from "react"
import { useState, useEffect } from "react"
import {
  Typography,
  Card,
  CardContent,
  CardHeader,
  TextField,
  Button,
  Box,
  Alert,
  Grid,
  Chip,
  Avatar,
} from "@mui/material"
import { Save, CheckCircle, Person } from "@mui/icons-material"
import FileUploader from "../leave/FileUploader"
import styles from "./OnboardingProfile.module.css"
import axios from "axios"
import { baseUrl, config, requestID, getUser, profileImgUrl } from "../../common/utils"
// import {
//   getEmployeeProfile,
//   updateEmployeeProfile,
//   uploadProfilePhoto
// } from "../../Services/OnboardingService2"

interface OnboardingProfileProps {
  employeeId: string
  isCompleted: boolean
  onComplete: () => void
}

interface ProfileData {
  accountName: string
  accountNumber: string
  address: string
  altEmail: string
  bankName: string
  phone: string
  firstName: string
  image: string
  lastName: string
  middleName: string
  nextKin: string
  nextOfKin: string
  nextOfKinAddress: string
  nextOfKinPhone: string
  nextOfKinRelationship: string
  nin: string
}

const OnboardingProfile: React.FC<OnboardingProfileProps> = ({ employeeId, isCompleted, onComplete }) => {
  const [profileData, setProfileData] = useState<ProfileData>({
    accountName: "",
    accountNumber: "",
    address: "",
    altEmail: "",
    bankName: "",
    phone: "",
    firstName: "",
    image: "",
    lastName: "",
    middleName: "",
    nextKin: "",
    nextOfKin: "",
    nextOfKinAddress: "",
    nextOfKinPhone: "",
    nextOfKinRelationship: "",
    nin: "",
  })

  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)
  const [profileStatus, setProfileStatus] = useState<"0" | "1">("0")
  const [imageUploaded, setImageUploaded] = useState(false)
  const [previewImage, setPreviewImage] = useState<string | null>(null)



  
  useEffect(() => {
    fetchProfileData()
  }, [employeeId])

  const fetchProfileData = async () => {
    try {
      setLoading(true)
      // const user = getUser().userData

      // Get profile data from recruitment/onboarding endpoint
      const response = await axios.post(
        `${baseUrl()}users/getprofile_bc`,
        {
          
          requestID: requestID(),
        },
        config,
      )

      console.log("Profile data response:", response)

      if (response.data && response.data.data) {
        const data = response.data.data
        setProfileData({
          accountName: data.accountName || "",
          accountNumber: data.accountNumber || "",
          address: data.address || "",
          altEmail: data.altEmail || "",
          bankName: data.bankName || "",
          phone: data.phone || "",
          firstName: data.firstName || "",
          image: data.image || "",
          lastName: data.lastName || "",
          middleName: data.middleName || "",
          nextKin: data.nextKin || "",
          nextOfKin: data.nextOfKin || "",
          nextOfKinAddress: data.nextOfKinAddress || "",
          nextOfKinPhone: data.nextOfKinPhone || "",
          nextOfKinRelationship: data.nextOfKinRelationship || "",
          nin: data.nin || "",
        })


        console.log(profileData.image)
        if (profileData.image) {
          setImageUploaded(true)
          }

        // Set profile status
        setProfileStatus(data.status || "0")

        // If status is "1", mark as completed
        if (data.status == "1") {
          onComplete()
        }
      }
    } catch (err) {
      setError("Failed to load profile data")
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  const handleInputChange = (field: keyof ProfileData, value: string) => {
    setProfileData((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  const handleImageUpload = async (files: File[]) => {
    if (files.length === 0) return

     const file = files[0]
  const previewUrl = URL.createObjectURL(file)
  setPreviewImage(previewUrl)  // <-- show preview in Avatar
    try {
      const formData = new FormData()
      formData.append("file", files[0])
      // formData.append("employeeId", employeeId)
      formData.append("requestID", requestID())
      

      const response = await axios.post(`${baseUrl()}onboardings/updateProfileImage_hr`, formData,
        config
        // {
        // ...config,
        // headers: {
        //   ...config.headers,
        //   "Content-Type": "multipart/form-data",
        // },
        // }
      )
      console.log("Image upload response:", response)

      if (response.data) {
        setProfileData((prev) => ({
          ...prev,
          image: response?.data?.data?.imageUrl || response?.data?.data?.image,
        }))
        setSuccess("Profile photo uploaded successfully!")
        setImageUploaded(true) // <-- enable other fields
        setTimeout(() => setSuccess(null), 3000)

        // Revoke preview and use server image
      // URL.revokeObjectURL(previewUrl)
      // setPreviewImage(null)
      }
    } catch (err) {
      setError("Failed to upload profile photo")
      console.error(err)
    }
  }

  const handleUpdateProfile = async () => {
    try {
      setSaving(true)
      setError(null)

      const user = getUser().userData
      console.log("profileData before update:", profileData)
      const { image, ...profileDataWithoutImage } = profileData; // Exclude image from update
      console.log("profileDataWithoutImage:", profileDataWithoutImage)
      const response = await axios.post(
        `${baseUrl()}onboardings/updateProfile_hr`,
        {
          // employeeId: employeeId,
          // user_id: user.user_id,
          // ...profileData,
          ...profileDataWithoutImage,
          requestID: requestID(),
        },
        config,
      )

      console.log("Update profile response:", response)

      if (response.data && response.data.status === 1) {
        setSuccess("Profile updated successfully!")
        setProfileStatus("1")
        setTimeout(() => {
          onComplete()
        }, 2000)
      } else {
        setError("Failed to update profile: " + (response.data?.message || "Unknown error"))
      }
    } catch (err) {
      setError("Failed to update profile")
      console.error(err)
    } finally {
      setSaving(false)
    }
  }

  const validateRequiredFields = () => {
    const requiredFields = [
      "firstName",
      "lastName",
      "phone",
      "address",
      "nin",
      "nextOfKin",
      "nextOfKinPhone",
      "nextOfKinRelationship",
      "nextOfKinAddress",
      "bankName",
      "accountName",
      "accountNumber",
    ]

    return requiredFields.every((field) => profileData[field as keyof ProfileData]?.trim() !== "")
  }


  console.log(`${profileImgUrl}${profileData.image}`)
  const getCompletionPercentage = () => {
    const totalFields = Object.keys(profileData).length
    const filledFields = Object.values(profileData).filter((value) => value?.trim() !== "").length
    return Math.round((filledFields / totalFields) * 100)
  }

  if (loading) {
    return (
      <Card className={styles.card}>
        <CardContent>
          <Typography>Loading profile data...</Typography>
        </CardContent>
      </Card>
    )
  }

  if (error) {
    return (
      <Alert severity="error" className={styles.error}>
        {error}
      </Alert>
    )
  }

  if (success) {
    return (
      <Alert severity="success" className={styles.success}>
        {success}
      </Alert>
    )
  }

  const completionPercentage = getCompletionPercentage()
  const isFormValid = validateRequiredFields()

  return (
    <div className={styles.container}>
      <Card className={styles.progressCard}>
        <CardHeader
          title="Profile Completion"
          subheader={`${completionPercentage}% completed`}
          action={
            profileStatus === "1" ? (
              <Chip label="Profile Complete" color="success" icon={<CheckCircle />} />
            ) : (
              <Chip label={`${completionPercentage}%`} color="primary" />
            )
          }
        />
      </Card>

      {profileStatus === "1" && (
        <Alert severity="success" className={styles.completedAlert}>
          <Typography variant="h6">Profile Completed!</Typography>
          <Typography>Your employee profile has been successfully completed.</Typography>
        </Alert>
      )}

      {!imageUploaded && (
  <Typography variant="body2" color="warning.main">
    Please upload a profile photo to continue filling the form.
  </Typography>
)}
      

      <Card className={styles.profileCard}>
        <CardHeader
          title="Employee Profile"
          subheader="Complete your detailed employee profile information"
          avatar={<Person />}
        />
        <CardContent>
          {/* Profile Photo Section */}
       <Box className={styles.photoSection}>
            <Avatar src={`${profileImgUrl}img/user/${profileData.image}` || previewImage } className={styles.avatar} sx={{ width: 100, height: 100 }}>
              {profileData.firstName?.[0]}
              {profileData.lastName?.[0]}
            </Avatar>

             {!imageUploaded &&   <FileUploader
              name="profilePhoto"
              accept="image/*"
              maxSize={5}
              description="Upload your profile photo"
              onFilesChange={handleImageUpload}
            />
          }
          </Box>

          <Grid container spacing={3}>
            {/* Personal Information */}
            <Grid item xs={12}>
              <Typography variant="h6" className={styles.sectionTitle}>
                Personal Information
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="First Name *"
                value={profileData.firstName}
                onChange={(e) => handleInputChange("firstName", e.target.value)}
                required
                disabled={!imageUploaded} // Disable until image is uploaded
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Middle Name"
                value={profileData.middleName}
                onChange={(e) => handleInputChange("middleName", e.target.value)}
                disabled={!imageUploaded} // Disable until image is uploaded
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Last Name *"
                value={profileData.lastName}
                onChange={(e) => handleInputChange("lastName", e.target.value)}
                required
                disabled={!imageUploaded} // Disable until image is uploaded
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Phone Number *"
                value={profileData.phone}
                onChange={(e) => handleInputChange("phone", e.target.value)}
                required
                disabled={!imageUploaded} // Disable until image is uploaded
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Alternative Email"
                type="email"
                value={profileData.altEmail}
                onChange={(e) => handleInputChange("altEmail", e.target.value)}
                disabled={!imageUploaded} // Disable until image is uploaded
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="NIN (National ID Number) *"
                value={profileData.nin}
                onChange={(e) => handleInputChange("nin", e.target.value)}
                required
                disabled={!imageUploaded} // Disable until image is uploaded
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Address *"
                multiline
                rows={2}
                value={profileData.address}
                onChange={(e) => handleInputChange("address", e.target.value)}
                required
                disabled={!imageUploaded} // Disable until image is uploaded
              />
            </Grid>

            {/* Next of Kin Information */}
            <Grid item xs={12}>
              <Typography variant="h6" className={styles.sectionTitle}>
                Next of Kin Information
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Next of Kin Name *"
                value={profileData.nextOfKin}
                onChange={(e) => handleInputChange("nextOfKin", e.target.value)}
                required
                disabled={!imageUploaded} // Disable until image is uploaded
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Relationship *"
                value={profileData.nextOfKinRelationship}
                onChange={(e) => handleInputChange("nextOfKinRelationship", e.target.value)}
                required
                disabled={!imageUploaded} // Disable until image is uploaded
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Next of Kin Phone *"
                value={profileData.nextOfKinPhone}
                onChange={(e) => handleInputChange("nextOfKinPhone", e.target.value)}
                required
                disabled={!imageUploaded} // Disable until image is uploaded
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Next of Kin Address *"
                multiline
                rows={2}
                value={profileData.nextOfKinAddress}
                onChange={(e) => handleInputChange("nextOfKinAddress", e.target.value)}
                required
                disabled={!imageUploaded} // Disable until image is uploaded
              />
            </Grid>

            {/* Banking Information */}
            <Grid item xs={12}>
              <Typography variant="h6" className={styles.sectionTitle}>
                Banking Information
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Bank Name *"
                value={profileData.bankName}
                onChange={(e) => handleInputChange("bankName", e.target.value)}
                required
                disabled={!imageUploaded} // Disable until image is uploaded
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Account Name *"
                value={profileData.accountName}
                onChange={(e) => handleInputChange("accountName", e.target.value)}
                required
                disabled={!imageUploaded} // Disable until image is uploaded
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Account Number *"
                value={profileData.accountNumber}
                onChange={(e) => handleInputChange("accountNumber", e.target.value)}
                required
                disabled={!imageUploaded} // Disable until image is uploaded
              />
            </Grid>

            {/* Legacy field - keeping for compatibility */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Next Kin (Legacy)"
                value={profileData.nextKin}
                onChange={(e) => handleInputChange("nextKin", e.target.value)}
                helperText="This field is for legacy compatibility"
              />
            </Grid>
          </Grid>

          {/* Action Buttons */}
          <Box className={styles.actionButtons}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleUpdateProfile}
              disabled={saving || !isFormValid || profileStatus === "1"}
              startIcon={<Save />}
              size="large"
            >
              {saving ? "Updating Profile..." : profileStatus === "1" ? "Profile Updated" : "Update Profile"}
            </Button>

            {!isFormValid && (
              <Typography variant="body2" color="error" className={styles.validationMessage}>
                Please fill in all required fields marked with *
              </Typography>
            )}
          </Box>
        </CardContent>
      </Card>
    </div>
  )
}

export default OnboardingProfile
